import { computed, ref, onMounted, onUnmounted } from 'vue'

// 检测是否为移动端/平板设备（基于 UA + 触摸能力）
function checkIsMobileDevice() {
  const ua = navigator.userAgent
  // Android 手机/平板、iPhone、iPod、HarmonyOS 设备
  if (/Android|iPhone|iPod|Mobile|Tablet|HarmonyOS|OpenHarmony|HUAWEI/i.test(ua)) return true
  // iPadOS 13+ 报告为 Macintosh，通过多点触摸区分
  if (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1) return true
  return false
}

// 移动端检测composable
export function useMobile() {
  const windowWidth = ref(window.innerWidth)
  const isMobileDevice = checkIsMobileDevice()
  
  // 移动设备始终为 true，桌面端窗口较窄时也切换为移动布局
  const isMobile = computed(() => isMobileDevice || windowWidth.value < 768)
  
  const handleResize = () => {
    windowWidth.value = window.innerWidth
  }
  
  onMounted(() => {
    window.addEventListener('resize', handleResize)
  })
  
  onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
  })
  
  // 手机：UA 含 Mobile/iPhone/iPod；平板：移动设备但不是手机
  const isPhone = computed(() => isMobileDevice && /iPhone|iPod|\bMobile\b/i.test(navigator.userAgent))
  const isTablet = computed(() => isMobileDevice && !isPhone.value)

  return {
    isMobile,
    isMobileDevice,
    isPhone,
    isTablet,
    windowWidth
  }
}

// 移动端拖拽状态管理
export function useMobileDrag() {
  const isDragMode = ref(false) // 是否处于拖拽模式
  const draggedListId = ref(null) // 当前拖拽的列表ID
  const currentListIndex = ref(0) // 当前显示的列表索引
  const dropTargetIndex = ref(null) // 放置目标索引
  
  // 进入拖拽模式
  const enterDragMode = (listId) => {
    isDragMode.value = true
    draggedListId.value = listId
  }
  
  // 退出拖拽模式
  const exitDragMode = () => {
    isDragMode.value = false
    draggedListId.value = null
    dropTargetIndex.value = null
  }
  
  // 切换到指定列表
  const switchToList = (index) => {
    currentListIndex.value = index
  }
  
  // 设置放置目标
  const setDropTarget = (index) => {
    dropTargetIndex.value = index
  }
  
  // 执行放置操作
  const performDrop = () => {
    // 这里会返回放置相关的信息
    const result = {
      draggedListId: draggedListId.value,
      fromIndex: currentListIndex.value,
      toIndex: dropTargetIndex.value
    }
    exitDragMode()
    return result
  }
  
  return {
    isDragMode,
    draggedListId,
    currentListIndex,
    dropTargetIndex,
    enterDragMode,
    exitDragMode,
    switchToList,
    setDropTarget,
    performDrop
  }
}

// 长按检测composable
export function useLongPress(callback = () => {}, delay = 500) {
  let timeoutId = null
  
  const startPress = (event, listId) => {
    // 清除之前的定时器
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    
    // 设置新的定时器
    timeoutId = setTimeout(() => {
      callback(listId)
    }, delay)
  }
  
  const cancelPress = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }
  
  return {
    startPress,
    cancelPress
  }
}
